<template>
  <div class="card card-fluid">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <span class="mr-auto">Primary form of ID</span>
        <div class="btn-job-title">
          <button class="btn btn-success btn-modal" v-b-modal.identity tabindex="0"  type="button" data-title="[Request]">
            <span>Add Identity</span>
          </button>
        </div>
      </div>
    </div><!-- /.card-header -->
    <div class="card-body">
      <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
        <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover :class="{'hide-scroll': isScrollHide()}">
          <template v-slot:cell(action)="row">
            <a class="btn btn-xs"  @click="detailRow(row.item, row.index, $event.target)" title="[Detail]" data-title="[Detail]" >
              <em class="fa fa-search"></em>
            </a>
            <a class="btn btn-xs"  @click="editRow(row.item, row.index, $event.target)" title="[Detail]" data-title="[Detail]" >
              <em class="fa fa-pencil-alt"></em>
            </a>
            <a class="btn btn-xs"  @click="deleteRow(row.item, row.index, $event.target)" title="[Detail]" data-title="[Detail]" >
              <em class="fa fa-trash"></em>
            </a>
          </template>
        </b-table>
        <div class="row align-items-center">
          <div class="col-sm-12 col-md-5">
            <div class="dataTables_info" id="data-table-leave-request-request_info" role="status" aria-live="polite">Showing {{currentPage}} to {{perPage}} of {{rows}} entries</div>
          </div>
          <div class="col-sm-12 col-md-7 d-flex justify-content-end">
            <div class="dataTables_paginate paging_simple_numbers">
              <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
            </div>
          </div>
        </div>
        <identity-input ref="mdl" :data="data"></identity-input>
        <identity-detail-modal ref="mdl-detail" :data="data"></identity-detail-modal>
      </div>
    </div>
    <b-modal id="modal-delete" hide-backdrop content-class="shadow" ref="modal-delete" title="Delete" @ok="deleteItem" @hide="resetModal" ok-title="Delete" ok-variant="danger">
      <p class="my-2">
        Are you sure delete this item ?
      </p>
    </b-modal>
  </div>
</template>

<script>
import {BTable, BPagination, VBModal, BModal} from "bootstrap-vue"
import {mapGetters} from "vuex";
import IdentityInput from "@/components/pages/identity/IdentityInput";
import {urlApi} from "../../../../config/url-api";
import AxiosCall from "../../../../libs/AxiosCall";
import IdentityDetailModal from "./IdentityDetailModal";
export default {
  name: "IdentityDetail",
  components:{
    IdentityDetailModal,
    IdentityInput,
    BTable,
    BPagination,
    BModal
  },
  directives:{
    'b-modal':VBModal
  },
  data(){
    return {
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'type_name',label:"ID Type", sortable: true},
        { key: 'registered_name', sortable: true },
        { key: 'registered_number', label:"ID Card Number", sortable: true },
        { key: 'valid_from', label:"Expiration Date",sortable: true },
        { key: 'last_modified', sortable: true },
      ],
      rows:20,
      perPage:5,
      currentPage:1,
      data:null
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },
  watch:{
    currentPage:function (){
      this.getData()
    }
  },
  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    getData(){
      this.items = []
      let payload = {
        page:this.currentPage,
        limit:this.perPage,
        emp_id:this.$store.getters.empId
      }
      AxiosCall.Get(payload, urlApi.identity.index).then(res=>{
        if(res.success){
          let no = (this.currentPage - 1) * this.perPage + 1
          for(let data of res.atributes){
            data.no = no++
            this.items.push(data)
          }
          this.rows = res.total
        }else {
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    editRow(item){
      this.data = item
      this.$refs.mdl.$refs.modal.show()
    },
    resetModal(){
      this.data = null
    },
    detailRow(item){
      this.data = item
      this.$refs["mdl-detail"].$refs.modal.show()
    },
    deleteRow(item){
      this.data = item
      this.$refs["modal-delete"].show()
    },
    deleteItem(){
      AxiosCall.Delete(urlApi.identity.delete+"/"+this.data.id).then(res=>{
        if (res.success){
          this.successMessage(res.message)
          this.getData()
          this.$refs["modal-delete"].hide()
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    }
  },
  mounted(){
    this.getData()
  }
}
</script>